import { render, staticRenderFns } from "./RdkmEdit.vue?vue&type=template&id=5afd6ce0"
import script from "./RdkmEdit.vue?vue&type=script&lang=ts"
export * from "./RdkmEdit.vue?vue&type=script&lang=ts"
import style0 from "./RdkmEdit.vue?vue&type=style&index=0&id=5afd6ce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports